<div class="modal-header">
    <span class="modal-title">Request Void Time Log</span>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form class="form-inline">
        <div class="form-group">
            <div class="input-group">
                <input class="form-control" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="currentDate" ngbDatepicker
                    #d="ngbDatepicker" (ngModelChange)="filterChange()" readonly>
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                </div>
            </div>
        </div>

        <div class="btn-group">
            <div class="input-group">
                <label for="typeahead-basic" class="padding-right">Search: </label>
                <input id="typeahead-basic" type="text" class="form-control" (input)="search($event)" />
            </div>
        </div>

    </form>

    <div class="margin-top">
        <div class="grid timeins justifycenter">
            <div class="row rowborder rowheader">
                <div class="col centerMedium flexcol">
                    Employee Code
                </div>
                <div class="col centerMedium flexcol">
                    Employee No
                </div>
                <div class="col centerMedium flexcol">
                    Fullname
                </div>
                <div class="col centerMedium flexcol">
                    Time In / Out
                </div>
                <div class="col centerMedium flexcol">
                    Latitude
                </div>
                <div class="col centerMedium flexcol">
                    Longitude
                </div>
                <div class="col centerMedium flexcol">

                </div>
            </div>
            <div class="row rowborder" *ngIf="logs?.length === 0">
                <div class="col centerMedium flexcol">
                    No Results Found
                </div>
            </div>
            <div class="row rowborder" *ngFor="let log of logs">
                <div class="col centerMedium flexcol">
                    {{log?.empcode}}
                </div>
                <div class="col centerMedium flexcol">
                    {{log?.empno}}
                </div>
                <div class="col centerMedium flexcol">
                    {{log?.fullname}}
                </div>
                <div class="col centerMedium flexcol">
                    {{log?.timereg}} {{log.ampm}}
                </div>
                <div class="col centerMedium flexcol">
                    {{log?.latitude}}
                </div>
                <div class="col centerMedium flexcol">
                    {{log?.longitude}}
                </div>
                <div class="col centerMedium flexcol">
                    <button class="btn btn-primary" *ngIf="log?.cancel_status !== ''" disabled>Requested</button>
                    <button class="btn btn-primary timeinrow" *ngIf="log?.cancel_status === ''"
                        (click)="requestVoid(log)">Request to
                        Void</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()">Close</button>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>